export default __webpack_public_path__ + "static/media/Tune_Upwards.95b9c767.jpg";